import React from "react";
import './Footer.scss';

const Footer = () => {
    return (
        <footer className="text-center">
            <h3>Footer</h3>
        </footer>
    )
}
export default Footer;
